import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext, HomeOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  oms: 'OMS',
  boqs: 'BOQ',
  'boq-categories': 'BOQ Categories',
  'sow-categories': 'SOW Categories',
  'boq-templates': 'Templates',
  'rate-cards': 'Rate Cards',
  procurement: 'Procurement',
  'purchase-requisitions': 'Purchase Requisitions',
  rfqs: 'RFQs',
  'purchase-orders': 'Purchase Orders',
  clients: 'Clients',
  projects: 'Projects',
  sites: 'Sites',
  vendors: 'Vendors',
  technicians: 'Technicians',
  employees: 'Employees',
  materials: 'Materials',
  'labour-rates': 'Labour Rates',
  users: 'Users',
  roles: 'Roles & Permissions',
  forbidden: 'Forbidden',
};

const labelFor = (seg: string): string =>
  LABELS[seg] ?? seg.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const segments = pathname.split('/').filter(Boolean);

  return (
    <MuiBreadcrumbs separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb" sx={{ fontSize: 13 }}>
      <Link
        component="button"
        type="button"
        underline="hover"
        color="inherit"
        onClick={() => navigate('/')}
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <HomeOutlined sx={{ fontSize: 16 }} />
        Home
      </Link>
      {segments.map((seg, idx) => {
        const path = `/${segments.slice(0, idx + 1).join('/')}`;
        const isLast = idx === segments.length - 1;
        return isLast ? (
          <Typography key={path} color="text.primary" fontWeight={600} fontSize={13}>
            {labelFor(seg)}
          </Typography>
        ) : (
          <Link key={path} component="button" type="button" underline="hover" color="inherit" onClick={() => navigate(path)}>
            {labelFor(seg)}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
}
